<template>
  <Modal title="不续费原因" v-model="visibleThis">
    <Form
      ref="editSalaryForm"
      class="form"
      :label-width="80"
      :complaintRow="attendanceRowThis"
      :model="attendanceRowThis"
    >
      <Row>
        <Col :span="22">
          <Row>
            <Form-item label="学生信息">
              <Input v-model="attendanceRowThis.nickname" disabled></Input>
            </Form-item>
          </Row>
        </Col>
        <Col :span="22">
          <Row>
            <Form-item label="一级原因">
              <Select v-model="attendanceRowThis.remark" placeholder="请选择">
                <Option v-for="item in $constant.stdOverRemark"
                        :value="item.text" :key="item.text">{{ item.text }}</Option>
              </Select>
            </Form-item>
          </Row>
        </Col>
        <Col :span="22">
          <Row>
            <Form-item label="其他原因">
              <Input v-model="attendanceRowThis.remarkExt"></Input>
            </Form-item>
          </Row>
        </Col>
        <Col :span="22">
          <Row>
            <Form-item label="附件图片">
              <multipleImageUpload 
                v-model="attendanceRowThis.attachmentUrls" 
                :defaultFileList="attachmentFileList"
                text="点击上传附件图片"
                :num="5"
                @on-file-change="handleAttachmentChange">
              </multipleImageUpload>
            </Form-item>
          </Row>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visibleThis = false">取消</Button>
      <Button
        type="primary"
        size="large"
        :loading="loadingEditSalary"
        @click="editSalary"
      >
        保存
      </Button>
    </div>
  </Modal>
</template>
<script>
import multipleImageUpload from '../../common/multipleImageUpload.vue'

export default {
  name: 'EditOverRemarkModal',
  components: {
    multipleImageUpload
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    complaintRow: {
      type: Object,
      default: {}
    },
    successCallback: {
      type: Function
    }
  },
  data () {
    let $constant = this.$constant
    return {
      visibleThis: this.visible,
      loadingEditSalary: false,
      attendanceRowThis: {},
      attachmentFileList: []
    }
  },
  methods: {
    editSalary () {
      let self = this
      self.loadingEditSalary = true
      // 将附件URL数组转换为字符串存储
      if (this.attendanceRowThis.attachmentUrls && Array.isArray(this.attendanceRowThis.attachmentUrls)) {
        this.attendanceRowThis.attachmentUrlsStr = this.attendanceRowThis.attachmentUrls.join(',')
      }
      self.$http.post('/tch/lesson/add-std-over-remark', this.attendanceRowThis).then(function (res) {
        if (res.status === 'ok') {
          self.$Message.success('成功!')
          self.visibleThis = false
          self.loadingEditSalary = false
          self.successCallback()
        }
      }).catch(function (e) {
        self.loadingEditSalary = false
      })
    },
    handleAttachmentChange (files) {
      // 处理附件变化，保存文件URL数组
      this.attendanceRowThis.attachmentUrls = files.map(file => file.url)
    },
  },
  watch: {
    visible (val) {
      this.visibleThis = val
    },
    visibleThis (val) {
      if (!val) {
        this.attendanceRowThis = {}
        this.$emit('on-close', val)
      }
    },
    complaintRow (val) {
      this.attendanceRowThis = val
      // 初始化附件列表
      this.attachmentFileList = []
      if (val.attachmentUrlsStr) {
        // 如果已有附件URL字符串，则解析为数组并构建默认文件列表
        const urls = val.attachmentUrlsStr.split(',')
        this.attachmentFileList = urls.filter(url => url).map((url, index) => ({
          uid: Date.now() + index,
          name: `image_${index}.jpg`,
          url: url,
          status: 'finished'
        }))
        // 同时设置attachmentUrls数组
        this.$set(this.attendanceRowThis, 'attachmentUrls', urls.filter(url => url))
      } else {
        this.$set(this.attendanceRowThis, 'attachmentUrls', [])
      }
      
      if (this.attendanceRowThis.status === 0) {
        this.complaintRemarkList.forEach(item => {
          if (item.text === val.remark) {
            this.attendanceRowThis.stdNum = item.stdNum
            this.attendanceRowThis.tchNum = item.tchNum
            this.attendanceRowThis.subSalary = item.subSalary
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// EditOverRemarkModal.vue?72f3ff4b